module.exports = __webpack_public_path__ + "static/media/pastevent2.7c79d15b.jpg";